export default "__VITE_ASSET__lkQ3hTmC__"